import { recordEventToDatadog } from "@/plugins/datadog"

export default {
  async sendEvent(eventName: string, metadata?: object) {
    recordEventToDatadog(eventName, metadata)
  },
}
